export default __webpack_public_path__ + "static/help-4240786590bf1447bed8a93a94e553cb.jpg";